import Repository from '@/libs/axios'

const cityResource = '/admin/city'
const cityByCoordinatesResource = '/admin/city-by-coordinates'

export default {
  uploadKml(kmlFile) {
    const form = new FormData()
    form.append('kml_file', kmlFile)
    return Repository.post(`${cityResource}/upload-kml`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  getCityByCoordinates(payload) {
    return Repository.post(`${cityByCoordinatesResource}`, payload)
  },
}
